import { useCallback } from 'react';

import { useLobbyURLConnected } from './useLobbyURLConnected';

export const useRedirectToLobbyCallbackConnected = (): (() => void) => {
  const lobbyURL = useLobbyURLConnected();
  return useCallback(() => {
    window.location.replace(lobbyURL);
  }, [lobbyURL]);
};
